import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAdmin } from '@/hooks/use-admin';

export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin, isLoaded } = useAdmin();

  if (!isLoaded) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
